import { setAdditionalPageInfo, setAuthenticationStatus, setSiteInfo } from './digitalDataBuilder';
import { getAnalyticsAuthenticationStatus, isB2BUser, getSiteInfo } from './thdUserInfo';
import { buildCategoryData } from './commonAnalytics';
import { getConfig } from '../../config';

const constructItemData = (omsId, productName, brand) => ({
  productInfo: {
    sku: `${omsId}` || '',
    productName: productName || '',
    manufacturer: `${brand}` || '',
    productType: 'merchandise',
  },
});
const setSite = () => {
  const siteInfo = {
    experienceType: window?.__EXPERIENCE_CONTEXT__.channel,
    betaSite: getSiteInfo() === 'origin' ? 'prod' : 'beta',
    businessType: isB2BUser() ? 'b2b' : 'b2c',
  };
  setSiteInfo(siteInfo);
};

const setTheHomeDepotCategoryObject = (omsId, productName, brand, omnitureInfo = {}) => {
  setAdditionalPageInfo('category', buildCategoryData(omnitureInfo));

  const pageInfoData = {
    pageLoadEvent: 'product view',
    pageName: `productdetails>${omsId}`,
    pageType: 'pip',
  };

  setAdditionalPageInfo('pageInfo', pageInfoData);

  const itemData = constructItemData(omsId, productName, brand);

  setAdditionalPageInfo('item', itemData);

  if (getConfig()?.isDebugToConsole) {
    // eslint-disable-next-line no-console
    console.log('window.digitalData', JSON.stringify(window.digitalData));
  }
};

export const customProductPipLoaded = (omsId, productName, brand, omnitureInfo) => {
  setTheHomeDepotCategoryObject(omsId, productName, brand, omnitureInfo);
  setAuthenticationStatus(getAnalyticsAuthenticationStatus());
  setSite();
};

export const trackConfiguratorPageLoad = (omsId, omnitureInfo, productName, brand) => {
  setAdditionalPageInfo('category', buildCategoryData(omnitureInfo));

  const pageInfoData = {
    pageName: `configurator>${omsId}`,
    pageType: 'tool:custom countertops:configurator',
  };

  setAdditionalPageInfo('pageInfo', pageInfoData);

  const itemData = constructItemData(omsId, productName, brand);

  setAdditionalPageInfo('item', itemData);

  setAuthenticationStatus(getAnalyticsAuthenticationStatus());
  setSite();
};
